"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSettingsLoader = useSettingsLoader;
const utils_1 = require("@juvare/common-web-ui/utils");
const shared_1 = require("../../../../backend/features/editable-settings/shared");
const hooks_1 = require("../../../../ui/hooks");
const stores_1 = require("../../../../ui/stores");
const react_redux_1 = require("react-redux");
const getSettings_1 = require("../stores/getSettings");
const settingsSlice_1 = require("../stores/settingsSlice");
function useSettingsLoader() {
    const status = (0, react_redux_1.useSelector)(getSettings_1.getSettingsLoadingStatus);
    const userLoggedIn = (0, react_redux_1.useSelector)(stores_1.isUserLoggedIn);
    const dispatch = (0, react_redux_1.useDispatch)();
    const storageClient = (0, hooks_1.useStorageClient)(shared_1.settingEntityName);
    return (0, hooks_1.usePreloader)({
        skip: !userLoggedIn,
        status: status,
        onLoad: () => {
            dispatch(settingsSlice_1.settingsSlice.actions.setLoading());
            return storageClient.list({});
        },
        onSuccess: (result) => {
            const settings = {};
            for (const row of result.rows) {
                settings[row.columns.name] = (0, shared_1.mapSettingValueFromRow)(row);
            }
            dispatch(settingsSlice_1.settingsSlice.actions.setSettings(settings));
        },
        onError: (error) => {
            dispatch(settingsSlice_1.settingsSlice.actions.setError((0, utils_1.getErrorMessage)(error)));
        },
    });
}
